/**
 * Infinity Checkout Integration
 */
document.addEventListener('DOMContentLoaded', function() {
  var buyNowButtons = document.querySelectorAll('#buyNowGumroad');
  var addToCartButtons = document.querySelectorAll('#addToCartButton');
  var quantityInput = document.querySelector('input[name="quantity"]') || document.querySelector('[data-quantity-input]');

  function getSelectedVariantId() {
    var variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) {
      return variantInput.value;
    }
    return window.infinityVariantId; // Fallback to global var if set in liquid
  }

  // Helper to fetch cart and redirect to Infinity checkout
  function processInfinityCheckout() {
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var domain = window.infinityCheckoutDomain || 'pay.drivi.store';
        var checkoutUrl = "https://" + domain + "/checkout?cart=";
        var cartData = {
          items: [],
          total: 0
        };

        cart.items.forEach(function(item) {
          var priceInCents = item.price;

          cartData.items.push({
            title: item.title,
            price: priceInCents,
            currency: 'USD',
            quantity: item.quantity,
            image: item.image || (item.featured_image ? item.featured_image.url : '')
          });

          cartData.total += priceInCents * item.quantity;
        });

        var jsonCartData = encodeURIComponent(JSON.stringify(cartData));
        checkoutUrl += jsonCartData;
        var storeName = window.infinityStoreName || 'Drivi';
        checkoutUrl += '&store=' + encodeURIComponent(storeName);
        
        var shopDomain = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : window.location.hostname;
        checkoutUrl += '&shop_domain=' + encodeURIComponent(shopDomain);
        
        window.location.href = checkoutUrl;
      })
      .catch(function(error) {
        console.error('Error processing Infinity checkout:', error);
      });
  }

  // Handle "Buy Now" (Gumroad/Infinity)
  if (buyNowButtons.length > 0) {
    buyNowButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        
        var variantId = getSelectedVariantId();
        
        // If we are on the product page and a variant ID is found, add to cart first
        if (variantId && document.getElementById('addToCartButton')) {
          var quantity = quantityInput ? (parseInt(quantityInput.value, 10) || 1) : 1;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              quantity: quantity,
              id: variantId
            })
          })
          .then(function() {
            processInfinityCheckout();
          })
          .catch(function(error) { console.error('Error adding item to cart:', error); });
        } else {
          // We are already on the cart page, just process checkout
          processInfinityCheckout();
        }
      });
    });
  }

  // Handle custom "Add to Cart" if required
  if (addToCartButtons.length > 0) {
    addToCartButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = getSelectedVariantId();
        var quantity = quantityInput ? (parseInt(quantityInput.value, 10) || 1) : 1;

        if (!variantId) {
          console.error('No variant selected');
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            quantity: quantity,
            id: variantId
          })
        })
        .then(function(response) {
          if (response.ok) {
            window.location.href = "/cart"; // Redirect to cart
          } else {
            console.error('Failed to add item to cart');
          }
        })
        .catch(function(error) {
          console.error('Error adding item to cart:', error);
        });
      });
    });
  }
});
